import { Modal } from '../ui/Modal';
import {
  formatDeliveryDays,
  type DeliveryScheduleIssueRow,
} from '../../lib/demCustomers';
import type { DemCustomer } from '../../types/dem';

type DeliveryScheduleIssuesModalProps = {
  open: boolean;
  onClose: () => void;
  rows: DeliveryScheduleIssueRow[];
  loading: boolean;
  error: string | null;
  onOpenCustomer: (customer: DemCustomer) => void;
};

export function DeliveryScheduleIssuesModal({
  open,
  onClose,
  rows,
  loading,
  error,
  onOpenCustomer,
}: DeliveryScheduleIssuesModalProps) {
  return (
    <Modal
      title="Delivery schedule issues"
      open={open}
      onClose={onClose}
      wide
    >
      <div className="dem-schedule-issues">
        <p className="dem-schedule-issues__lead">
          Active customers whose NAV <code>delivery_schedule</code> is empty, has typos, cannot be
          parsed, or does not match the saved delivery days. Click a row to review and adjust.
        </p>

        {loading ? (
          <div className="empty-state">
            <div className="empty-state__spinner" />
            <p>Scanning schedules…</p>
          </div>
        ) : error ? (
          <p className="alert alert-error">{error}</p>
        ) : rows.length === 0 ? (
          <div className="empty-state">
            <p>No schedule issues found.</p>
          </div>
        ) : (
          <div className="dem-schedule-issues__list" role="list">
            {rows.map(({ customer, issues, parsedDays }) => (
              <button
                key={customer.code}
                type="button"
                className="dem-schedule-issues__row"
                role="listitem"
                onClick={() => onOpenCustomer(customer)}
              >
                <span className="dem-schedule-issues__code">{customer.code}</span>
                <span className="dem-schedule-issues__name" title={customer.name}>
                  {customer.name}
                </span>
                <span className="dem-schedule-issues__nav" title={customer.delivery_schedule || '(empty)'}>
                  NAV: {customer.delivery_schedule.trim() || '—'}
                </span>
                <span className="dem-schedule-issues__meta">
                  Saved: {formatDeliveryDays(customer.allowed_days)}
                  {parsedDays != null ? ` · Parsed: ${formatDeliveryDays(parsedDays)}` : ''}
                </span>
                <span className="dem-schedule-issues__tags">
                  {issues.map((issue) => (
                    <span
                      key={`${issue.kind}:${issue.label}`}
                      className={`dem-schedule-issues__tag dem-schedule-issues__tag--${issue.kind}`}
                    >
                      {issue.label}
                    </span>
                  ))}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
